/* eslint-env browser */
/* eslint no-unused-vars: 0 */
import isArray from 'lodash/isArray';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
var supportsBeacon = Boolean(window.navigator.sendBeacon);
export default function send(url, data, sdkConfig) {
  if (sdkConfig.useBeacon && sdkConfig.useBeaconWhenAvailable && supportsBeacon) {
    var result = window.navigator.sendBeacon(url, JSON.stringify(data));
    if (result) {
      return Promise.resolve(true);
    }
    return Promise.reject(false);
  }
  var request = fetch(url, {
    headers: new Headers({
      'Content-Type': 'application/x-www-form-urlencoded'
    }),
    method: 'POST',
    body: JSON.stringify(data)
  });
  return request.then(function (response) {
    if (response.status >= 400) {
      return Promise.reject('Response status >= 400');
    }
    return Promise.resolve(response);
  });
}